import { oz } from '@weft/utils';

export const PRICING_MODELS = Object.freeze({
  Subscription: 'Subscription',
  FixedOneTime: 'FixedOneTime',
  FixedPerUnit: 'FixedPerUnit',
  CommercialTerms: 'CommercialTerms',
  Installments: 'Installments',
  Tiers: 'Tiers',
  TieredSubscription: 'TieredSubscription',
  PerUnit: 'PerUnit',
  Commission: 'Commission',
  Refund: 'Refund',
});

export const PricingModelSchema = oz.nativeEnum(PRICING_MODELS).openapi('PricingModel');

export type PricingModel = oz.infer<typeof PricingModelSchema>;